export default __webpack_public_path__ + "static/media/glucernaLiq3.32afb448.png";